import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Content = styled.div`
    width:100%;
    padding:1.2rem 2rem;
    background:#fff;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    height:75vh;
    margin-top: 1rem;
    position: relative;
`;

export const TitleLeft = styled.div`
    display:flex;
    flex-direction: row;
    gap:1rem;
    justify-content: space-between;
    align-self: end;
    span:nth-of-type(1){
        font-size: 20px;
        font-weight: 600;
    }
    span:nth-of-type(2){
        color:#414141;
        font-size: 14px;
        font-weight: 500;
        height: 100%;
        margin-top: auto;
    }
`;

export const DataListWrap = styled.div`
    height:calc(100% - 98px );
    overflow:auto;  
    scrollbar-width: thin;

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background-color: darkgrey;
    }
    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
`;

export const DashList = styled.table`
    width:100%;
    margin-top: 1rem;
    border-collapse: collapse;

    td{
        font-size: 14px;
        padding:5px 10px;

        &:last-of-type{
            text-align: right;
        }
    }

    tr:not(:nth-of-type(1)){
        td{

            height: 34px;
        }
    }

    tr:nth-of-type(even){
            background:#a7a7a71f;
    }

    span{
        display:block;
        white-space: nowrap;
    }

    .right{
        text-align: right;
    }

    .width40{
        width:40%;
    }

    .width20{
        width:20%;
    }
`;

export const Td = styled.td<{}>`
    font-size: 16px !important;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    white-space: nowrap;
    font-weight: 600;

    svg{
        height:14px;
    }
    &:hover{
        background:#f8f8f8;
    }
`;

export const Img = styled.div`
    width:34px;
    height:34px; 
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 0 2px rgba(0,0,0,0.25);
`;

export const PickButton = styled.button`
    font-size: 12px;
    font-weight: 400;
    background:#2A848E;
    color:#fff;
    padding:0.5rem 1rem;
    border-radius: 20px;
    white-space: nowrap;

    &:hover{
        opacity: 0.8;
    }
`;

export const ActionBar = styled.div`
    display:flex;
    gap:1rem;
    margin-left: auto;
    justify-content: end;

    svg{
        cursor: pointer;
        width:18px;

        path{
            fill:#888888;
        }

        :hover{
            opacity: 0.8;
        }
    }
`;